__turbopack_context__.v({
  "active": "Calculator-module-scss-module__mx37ba__active",
  "bank_container": "Calculator-module-scss-module__mx37ba__bank_container",
  "bank_emptyList": "Calculator-module-scss-module__mx37ba__bank_emptyList",
  "bank_list": "Calculator-module-scss-module__mx37ba__bank_list",
  "bank_list__callButton": "Calculator-module-scss-module__mx37ba__bank_list__callButton",
  "bank_list__notification": "Calculator-module-scss-module__mx37ba__bank_list__notification",
  "bank_list__result": "Calculator-module-scss-module__mx37ba__bank_list__result",
  "bank_list__wrapperNotification": "Calculator-module-scss-module__mx37ba__bank_list__wrapperNotification",
  "btn": "Calculator-module-scss-module__mx37ba__btn",
  "calc_block": "Calculator-module-scss-module__mx37ba__calc_block",
  "calc_checkbox": "Calculator-module-scss-module__mx37ba__calc_checkbox",
  "calc_checkbox__desc": "Calculator-module-scss-module__mx37ba__calc_checkbox__desc",
  "calc_checkbox__input": "Calculator-module-scss-module__mx37ba__calc_checkbox__input",
  "calc_checkbox__label": "Calculator-module-scss-module__mx37ba__calc_checkbox__label",
  "calc_checkbox_block": "Calculator-module-scss-module__mx37ba__calc_checkbox_block",
  "calc_chosedProgram": "Calculator-module-scss-module__mx37ba__calc_chosedProgram",
  "calc_container": "Calculator-module-scss-module__mx37ba__calc_container",
  "calc_dropdown": "Calculator-module-scss-module__mx37ba__calc_dropdown",
  "calc_flats": "Calculator-module-scss-module__mx37ba__calc_flats",
  "calc_flats__select": "Calculator-module-scss-module__mx37ba__calc_flats__select",
  "calc_main": "Calculator-module-scss-module__mx37ba__calc_main",
  "calc_programs": "Calculator-module-scss-module__mx37ba__calc_programs",
  "calc_programs_item": "Calculator-module-scss-module__mx37ba__calc_programs_item",
  "calc_svgArrows": "Calculator-module-scss-module__mx37ba__calc_svgArrows",
  "calc_svgRotate": "Calculator-module-scss-module__mx37ba__calc_svgRotate",
  "calc_title": "Calculator-module-scss-module__mx37ba__calc_title",
  "familyInfoText": "Calculator-module-scss-module__mx37ba__familyInfoText",
  "flats_btn": "Calculator-module-scss-module__mx37ba__flats_btn",
  "flats_btn__active": "Calculator-module-scss-module__mx37ba__flats_btn__active",
  "grid": "Calculator-module-scss-module__mx37ba__grid",
  "hintFilterBtns": "Calculator-module-scss-module__mx37ba__hintFilterBtns",
  "insurance": "Calculator-module-scss-module__mx37ba__insurance",
  "sum_credit": "Calculator-module-scss-module__mx37ba__sum_credit",
  "sum_credit_block": "Calculator-module-scss-module__mx37ba__sum_credit_block",
  "terms_calc_container": "Calculator-module-scss-module__mx37ba__terms_calc_container",
});
